module.exports = __webpack_public_path__ + "img/ic_ecommerce.999b23d7.svg";